import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LEGACY_SESSION_COOKIE_PATHS, SESSION_COOKIE_PATH } from '@constants';
import { SessionCookies } from '@enums';
import { RolesStorageService } from '@services';

/** Owns the client-side session: the one place that knows what ending it clears. */
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(
    private cookieService: CookieService,
    private rolesStorageService: RolesStorageService,
  ) {}

  /**
   * Deletes the session cookies (on the path they are set with, and on the
   * legacy paths older builds used) and the stored roles.
   */
  public clear(): void {
    for (const path of [SESSION_COOKIE_PATH, ...LEGACY_SESSION_COOKIE_PATHS]) {
      for (const key of Object.values(SessionCookies)) {
        this.cookieService.delete(key, path);
      }
    }
    this.rolesStorageService.clear();
  }
}
